
import { mapGetters } from "vuex";
import UiInputWrapper from "~/components/UI/UiInputWrapper";
import UiInput from "~/components/UI/UiInput";
import UiButton from "~/components/UI/UiButton";

export default {
  name: "RegisterForm",
  components: {
    UiButton,
    UiInput,
    UiInputWrapper,
  },
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        password: "",
        email: "",
      },
      loading: false,
      passwordVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      getCurrentLangId: "general/getCurrentLangId",
    }),
  },
  methods: {
    async onSubmit() {
      if (this.loading) return;
      this.loading = true;
      try {
        await this.$api.auth.signUp({
          ...this.form,
          language_id: this.getCurrentLangId(this.$i18n.locale),
        });
        this.$alert({
          title: `${this.$t("success")}!`,
          text: `${this.$t("confirmMessage")}.`,
        });
      } catch (error) {
        if (
          error.response.data.errors[0].property &&
          Object.hasOwn(this.form, error.response.data.errors[0].property)
        ) {
          this.$refs.form.setErrors({
            [error.response.data.errors[0].property]:
              error.response.data.errors[0].message,
          });
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
